<template>
    <tabs :options="{ useUrlFragment: false }" nav-class="nav nav-pills m-3" nav-item-class="nav-item col-md-4 col-sm-12 text-center" nav-item-link-class="nav-link btn-dashboard-sub-nav" nav-item-link-active-class="active">
        <tab prefix="<h2 class='mt-2'>" suffix=" / <i class='far fa-clock text-primary'></i></h4>" name="Pending">
            <hr class="w-75 mx-auto" />
            <alerts :alerts="alerts" />
            <div class="row mx-auto my-3">
                <div class="col-sm-12 col-md-6">
                    <pending-visits :pending_visits="pending_visits" :pending_visits_total="pending_visits_total" :visit_loading="pending_visits_loading" v-on:change-page="changePage" />
                </div>
                <div class="col-sm-12 col-md-6">
                    <financial-report :financial_data="financial_data" />
                </div>
            </div>
        </tab>
        <tab prefix="<h2 class='mt-2'>" suffix=" / <i class='far fa-calendar-alt text-primary'></i></h4>" name="Scheduled">
            <hr class="w-75 mx-auto" />
            <alerts :alerts="alerts" />
            <div class="row mx-auto my-3">
                <div class="col-sm-12 col-md-6">
                    <scheduled-visits :scheduled_visits="scheduled_visits" :scheduled_visits_total="scheduled_visits_total" :visit_loading="scheduled_visits_loading" v-on:change-page="changePage" />
                </div>
                <div class="col-sm-12 col-md-6">
                    <financial-report :financial_data="financial_data" />
                    <scheduled-training-sessions :scheduled_training_sessions="scheduled_training_sessions" :scheduled_training_sessions_total="scheduled_training_sessions_total" :loading="scheduled_training_sessions_loading" v-on:change-page="changePage" />
                </div>
            </div>
        </tab>
        <tab prefix="<h2 class='mt-2'>" suffix=" / <i class='fas fa-check text-primary'></i></h4>" name="Completed">
            <hr class="w-75 mx-auto" />
            <alerts :alerts="alerts" />
            <div class="row mx-auto my-3">
                <div class="col-sm-12 col-md-6">
                    <completed-visits :completed_visits="completed_visits" :completed_visits_total="completed_visits_total" :visit_loading="completed_visits_loading" v-on:change-page="changePage" />
                    <completed-training-sessions :completed_training_sessions="completed_training_sessions" :completed_training_sessions_total="completed_training_sessions_total" :loading="completed_training_sessions_loading" v-on:change-page="changePage" />
                </div>
                <div class="col-sm-12 col-md-6">
                    <financial-report :financial_data="financial_data" />
                    <canceled-visits :canceled_visits="canceled_visits" :visit_loading="canceled_visits_loading" />
                    <canceled-training-sessions :canceled_training_sessions="canceled_training_sessions" :canceled_training_sessions_total="canceled_training_sessions_total" :loading="canceled_training_sessions_loading" v-on:change-page="changePage" />
                </div>
            </div>
        </tab>
    </tabs>
</template>

<script lang="ts">
    import {defineComponent,ref} from "vue";
    import { store } from '../../store/index';
    import {Tabs, Tab} from 'vue3-tabs-component';
    import CanceledTrainingSessions from '@/components/dashboard/canceled-training-sessions.vue';
    import CanceledVisits from '@/components/dashboard/canceled-visits.vue';
    import CompletedTrainingSessions from '@/components/dashboard/completed-training-sessions.vue';
    import CompletedVisits from '@/components/dashboard/completed-visits.vue';
    import FinancialReport from '@/components/dashboard/financial-report.vue';
    import moment from 'moment';
    import PendingVisits from '@/components/dashboard/pending-visits.vue';
    import router from "@/router";
    import ScheduledTrainingSessions from '@/components/dashboard/scheduled-training-sessions.vue';
    import ScheduledVisits from '@/components/dashboard/scheduled-visits.vue';
    import Visit from '@/models/visit';
    import Alerts from "@/views/dashboards/alerts.vue";


    export default defineComponent({
        components: {
            Alerts,
            CanceledTrainingSessions,
            CanceledVisits,
            CompletedTrainingSessions,
            CompletedVisits,
            FinancialReport,
            PendingVisits,
            ScheduledTrainingSessions,
            ScheduledVisits,
            Tab,
            Tabs
        },
        mounted() {
            this.getVisitData(0,'all');
            this.getFinancialData();
        },
        setup() {
            const alerts = ref({});
            const pending_visits = ref([]);
            const pending_visits_total = ref(0);
            const pending_visits_loading = ref<Boolean>(true);
            const scheduled_visits = ref([]);
            const scheduled_visits_total = ref(0);
            const scheduled_visits_loading = ref<Boolean>(true);
            const completed_visits = ref([]);
            const completed_visits_total = ref(0);
            const completed_visits_loading = ref<Boolean>(true);
            const canceled_visits = ref([]);
            const canceled_visits_loading = ref<Boolean>(true);
            const scheduled_training_sessions = ref([]);
            const scheduled_training_sessions_total = ref(0);
            const scheduled_training_sessions_loading = ref<Boolean>(true);
            const completed_training_sessions = ref([]);
            const completed_training_sessions_total = ref(0);
            const completed_training_sessions_loading = ref<Boolean>(true);
            const canceled_training_sessions = ref([]);
            const canceled_training_sessions_total = ref(0);
            const canceled_training_sessions_loading = ref<Boolean>(true);
            const financial_data = ref({});
            const getFinancialData = async() => {
                var post_data:any = {
                    month: moment().format('M'),
                    year: moment().format('YYYY'),
                    user_id: store.getters.user.props.id,
                    is_author: false
                };
                if(store.getters.partner.id !== 1){
                    post_data.partner_id = store.getters.partner.id;
                }
                Visit.getFinancialData(post_data).then((res)=>{
                    financial_data.value = {
                        completed_total: res.data.completed_total,
                        scorecards_total: res.data.scorecards_total,
                        training_sessions_total: res.data.training_sessions_total,
                        late_cancellations_total: res.data.late_cancellations_total,
                        early_cancellations_total: res.data.early_cancellations_total,
                        no_shows_total: res.data.no_shows_total,
                        learner_technical_issues_total: res.data.learner_technical_issues_total,
                        interviews_total: res.data.interviews_total,
                        authoring_total: res.data.authoring_total,
                        total: res.data.total,
                    };
                },(err)=>{
                    console.log(err);
                });
            };
            const getVisitData = async(page_start:Number,type:String) => {
                if(type == 'all' || type == 'requests'){
                    pending_visits_loading.value = true;
                }
                if(type == 'all' || type == 'scheduled'){
                    scheduled_visits_loading.value = true;
                }
                if(type == 'all' || type == 'completed'){
                    completed_visits_loading.value = true;
                }
                if(type == 'all' || type == 'scheduled_training_sessions'){
                    scheduled_training_sessions_loading.value = true;
                }
                if(type == 'all' || type == 'completed_training_sessions'){
                    completed_training_sessions_loading.value = true;
                }
                if(type == 'all' || type == 'canceled_training_sessions'){
                    canceled_training_sessions_loading.value = true;
                }
                if(type == 'all'){
                    canceled_visits_loading.value = true;
                }
                var post_data = {
                    user_id: store.getters.user.props.id,
                    role_id: store.getters.dashboard_view,
                    page_start: page_start,
                    type: type
                };
                Visit.getUserVisits(post_data).then((res)=>{
                    if(type == 'all' || type == 'requests'){
                        pending_visits.value = res.data.visit_requests;
                        pending_visits_total.value = res.data.visit_requests_total;
                        pending_visits_loading.value = false;
                    }
                    if(type == 'all' || type == 'scheduled'){
                        scheduled_visits.value = res.data.scheduled_visits;
                        scheduled_visits_total.value = res.data.scheduled_visits_total;
                        scheduled_visits_loading.value = false;
                    }
                    if(type == 'all' || type == 'completed'){
                        completed_visits.value = res.data.completed_visits;
                        completed_visits_total.value = res.data.completed_visits_total;
                        completed_visits_loading.value = false;
                    }
                    if(type == 'all' || type == 'scheduled_training_sessions'){
                        scheduled_training_sessions.value = res.data.scheduled_training_sessions;
                        scheduled_training_sessions_total.value = res.data.scheduled_training_sessions_total;
                        scheduled_training_sessions_loading.value = false;
                    }
                    if(type == 'all' || type == 'completed_training_sessions'){
                        completed_training_sessions.value = res.data.completed_training_sessions;
                        completed_training_sessions_total.value = res.data.completed_training_sessions_total;
                        completed_training_sessions_loading.value = false;
                    }
                    if(type == 'all' || type == 'canceled_training_sessions'){
                        canceled_training_sessions.value = res.data.canceled_training_sessions;
                        canceled_training_sessions_total.value = res.data.canceled_training_sessions_total;
                        canceled_training_sessions_loading.value = false;
                    }
                    if(type == 'all'){
                        canceled_visits.value = res.data.canceled_visits;
                        canceled_visits_loading.value = false;
                        alerts.value = res.data.alerts;
                    }
                },(err)=>{
                    console.log(err);
                });
            };

            const changePage = (vars:any) => {
                getVisitData(vars.page_start,vars.type);
            }
            return {
                alerts,
                changePage,
                pending_visits,
                pending_visits_total,
                pending_visits_loading,
                scheduled_visits,
                scheduled_visits_total,
                scheduled_visits_loading,
                completed_visits,
                completed_visits_total,
                completed_visits_loading,
                canceled_visits,
                canceled_visits_loading,
                scheduled_training_sessions,
                scheduled_training_sessions_total,
                scheduled_training_sessions_loading,
                completed_training_sessions,
                completed_training_sessions_total,
                completed_training_sessions_loading,
                canceled_training_sessions,
                canceled_training_sessions_total,
                canceled_training_sessions_loading,
                financial_data,
                getFinancialData,
                getVisitData,
                moment,
                router,
            };
        }
    });
</script>
